import React from 'react'

import AssessmentListingPage from 'src/consumer/components/AssessmentsListingPage'

export default function PatientAssessmentsPage() {
  return (
    <AssessmentListingPage
      embedded
      linkBase="/patient-home/assessments"
    />
  )
}
